import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import storage from "../../../../Storage";
import socket from "../../../../Socket";
import { decode, encode, wait, sendNotfication } from "../../../../Helper";
import C from "../../../../Constant";

class Security extends React.Component {
    _isMounted = false;
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            disabled: false,
            password: '',
            _password: '',
        };
        this.saveUserSetting = this.saveUserSetting.bind(this);
    }

    componentDidMount() {
        this._isMounted = true;
        socket.on(C.EDIT_PASSWORD, data => this.updateProfile(decode(data)));
    }

    componentWillMount() {
        wait(500).then(() => {
            this.setState({ loading: false });
        })
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    saveUserSetting(e) {
        if (this._isMounted) {
            wait(750).then(() => {
                socket.emit(C.EDIT_PASSWORD, encode({
                    token: storage.getKey('token'),
                    password: this.state.password
                }));
            })
        }
    }

    updateProfile(data) {
        if (this._isMounted) {
            this.setState({ disabled: false });
            if (data.status) {
                return sendNotfication('Your Account Password was Updated ', 'success', 'top-center');
            }
            else {
                return sendNotfication(data.error, 'error', 'top-center');
            }
        }
    }

    back = () => {
        this.props.clicked();
    };

    render() {
        return (
            <>
                {this.state.loading ?
                    <>
                        <div className="text-center" style={{ minHeight: 150 }}>
                            <div class="spinner-border text-info my-2 user-loader" role="status" />
                        </div>
                    </>
                    :
                    <Form className="auth-form"
                        onSubmit={e => {
                            e.preventDefault();

                            if (!this.state.password) {
                                document.getElementById('password').classList.add('border-danger');
                                return;
                            }

                            if (!this.state._password) {
                                document.getElementById('_password').classList.add('border-danger');
                                return;
                            }

                            if (this.state.password !== this.state._password) {
                                sendNotfication('Passwords is different!', 'error', 'top-center');
                            }

                            if (this.state.password === this.state._password) {
                                this.setState({ disabled: true });
                                this.saveUserSetting(e);
                            }
                        }}
                    >
                        <div className="mb-4">
                            <label className="text-white opacity-70 mb-2 small font-weight-bold">New Password</label>
                            <div className="auth-input-wrapper">
                                <i className="mdi mdi-lock-outline" />
                                <input
                                    type="password"
                                    id="password"
                                    autoComplete={'off'}
                                    className="form-control auth-input-custom"
                                    value={this.state.password}
                                    required={true}
                                    placeholder="Enter New Password"
                                    onChange={e => this.setState({ password: e.target.value })}
                                />
                            </div>
                        </div>

                        <div className="mb-4">
                            <label className="text-white opacity-70 mb-2 small font-weight-bold">Confirm New Password</label>
                            <div className="auth-input-wrapper">
                                <i className="mdi mdi-lock-check-outline" />
                                <input
                                    type="password"
                                    id="_password"
                                    autoComplete={'off'}
                                    className="form-control auth-input-custom"
                                    value={this.state._password}
                                    required={true}
                                    placeholder="Confirm New Password"
                                    onChange={e => this.setState({ _password: e.target.value })}
                                />
                            </div>
                        </div>

                        <div className="mt-4 pt-2">
                            <button type="submit" className="auth-btn-primary mb-3" disabled={this.state.disabled}>
                                {this.state.disabled ? (
                                    <><i className="mdi mdi-loading mdi-spin mr-2" /> Updating...</>
                                ) : (
                                    <><i className="mdi mdi-content-save-outline mr-2" /> Update Password</>
                                )}
                            </button>

                            <button type="button" className="btn btn-link text-white opacity-50 btn-block font-weight-bold" onClick={this.back} style={{ textDecoration: 'none' }}>
                                <i className="mdi mdi-arrow-left mr-1" /> Back to Profile
                            </button>
                        </div>
                    </Form>
                }
            </>
        );
    }
}

export default Security;